// 神策统计相关
import sa from 'sa-sdk-javascript'
import _ from 'lodash'
// 区分本地环境和线上环境
const projectMode = process.env.VUE_APP_ENV_MICRO === 'production' ? 'default' : 'mt_user_dev'

export default class {
  _channelFrom = '0'
  constructor ({channelFrom, platform, brand}) {
    this._channelFrom = channelFrom || '0'
    platform = platform || 'h5'
    brand = brand || 'himo'
    this._init(this._channelFrom, platform, brand)
  }
  _init (channelFrom, platform, brand) {
    // 神策数据初始化
    sa.init({
      name: 'sa',
      web_url: 'https://sc.hzmantu.com:8107/?project=' + projectMode,
      server_url: 'https://sc.hzmantu.com:8106/sa?project=' + projectMode,
      show_log: false,
      heatmap: {
        // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
        clickmap: 'default',
        // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
        scroll_notice_map: 'default'
      }
    })
    // sa.quick('autoTrack', {
    //   brand: 'himo',
    //   channel_from: channelFrom
    // })
    sa.registerPage({
      app_name: 'himo',
      brand: brand,
      channel_from: channelFrom,
      platform_type: platform
    });
  }
  login (userid) {
    sa.login(userid)
  }
  autoTrackSinglePage () {
    sa.quick('autoTrackSinglePage')
  }
  track (name, data, option = {}) {
    let scopeData = _.assign({}, data)
    if (!option.noChannel) scopeData.channel_from = this._channelFrom
    if (!option.noPlatform) scopeData.platform_id = 1
    sa.track(name, scopeData)
  }
  // 修改 H5 上报数据的 distinctID
  identify(distinctID) {
    sa.identify(distinctID, true)
  }
  get channelFrom () {
    return this._channelFrom
  }
}
